import { useForm } from "@formspree/react";
import NewsletterCTA from "../components/NewsletterCTA";

const INTRO = `We are sorry to see you go!
Enter your email address to unsubscribe. You will no longer receive updates about case settlements, deadlines, and legal news.`;

export default function Unsubscribe() {
  const [state, handleSubmit] = useForm("mandyayr");

  return (
    <main className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold text-[#0A2540]">Unsubscribe</h1>
      <pre className="mt-3 whitespace-pre-wrap text-slate-700 font-sans text-[15px] leading-7">
        {INTRO}
      </pre>

      {state.succeeded ? (
        <div className="mt-6 rounded-lg bg-green-600/10 text-green-800 px-4 py-3">
          You’ve been unsubscribed. It may take a short time for all emails to stop.
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="mt-6 grid gap-3 sm:grid-cols-3">
          <input
            className="rounded-lg border border-slate-300 px-3 py-2 outline-none focus:ring-2 focus:ring-[#C89B3C]"
            name="email"
            type="email"
            placeholder="Enter your email *"
            required
          />
          <div className="sm:col-span-2">
            <button
              type="submit"
              disabled={state.submitting}
              className="inline-flex items-center justify-center rounded-full px-5 py-3 font-semibold text-white
                         bg-[#C89B3C] hover:bg-[#B8872D] transition"
            >
              <svg className="mr-2" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22Z" />
              </svg>
              Unsubscribe
            </button>
          </div>
          <input type="hidden" name="formType" value="unsubscribe" />
        </form>
      )}

      <NewsletterCTA />
    </main>
  );
}
